import { useState } from 'react';
import Button from '../../../../../components/Button';
import DatePicker from '../../../../../components/DatePicker';
import Input from '../../../../../components/Input';
import Modal from '../../../../../components/Modal'
import PhoneNumberInput from '../../../../../components/PhoneNumberInput';
import { errorMessages } from '../../../../../config/notification';
import { useDispatch, useSelector } from '../../../../../store/store';
import { birthDateValidation, fromDatePickerFormat, toDatePickerFormat } from '../../../../../utils/dateHelpers';
import styles from './style.module.scss';
import { DayValue } from '@amir04lm26/react-modern-calendar-date-picker';
import { selectUpdatingProfileData, selectUserAttributes } from '../../../../../store/workspace/selectors';
import { updatePersonalInformationThunk } from '../../../../../store/workspace/thunks';
import { setEditPersonalInfoModal } from '../../../../../store/workspace/slice';

export default function EditPersonalInformation() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectUpdatingProfileData);
    const userAttributes = useSelector(selectUserAttributes);
    const [city, setCity] = useState(userAttributes?.['custom:city'] || '');
    const [state, setState] = useState(userAttributes?.['custom:state'] || '');
    const [address, setAddress] = useState(userAttributes?.address || '');
    const [country, setCountry] = useState(userAttributes?.['custom:country'] || '');
    const [zipCode, setZipCode] = useState(userAttributes?.['custom:zipCode'] || '');
    const [lastName, setLastName] = useState(userAttributes?.family_name || '');
    const [firstName, setFirstName] = useState(userAttributes?.given_name || '');
    const [linkedinLink, setLinkedinLink] = useState(userAttributes?.['custom:linkedinLink'] || '');
    const [preferredName, setPreferredName] = useState(userAttributes?.['custom:preferredName'] || '');
    const [phoneNumber, setPhoneNumber] = useState<string | undefined>(userAttributes?.phone_number);
    const [DOB, setDOB] = useState<DayValue>(userAttributes?.birthdate ? toDatePickerFormat(userAttributes.birthdate) : null);

    const next = () => {
        dispatch(updatePersonalInformationThunk({
            city,
            state,
            zipCode,
            address,
            country,
            lastName,
            firstName,
            phoneNumber,
            linkedinLink,
            preferredName,
            email: userAttributes?.email || '',
            birthDate: fromDatePickerFormat(DOB),
        }));
    };

    return (
        <Modal
            size='md'
            childClassName={styles.wrapper}
            title='Edit personal information'
            closeFunc={() => dispatch(setEditPersonalInfoModal(false))}
        >
            <Input
                label='First name'
                type='text'
                placeholder=''
                value={firstName}
                onChange={setFirstName}
            />
            <Input
                label='Last name'
                type='text'
                placeholder=''
                value={lastName}
                onChange={setLastName}
            />
            <Input
                label='Preferred name (Optional)'
                type='text'
                placeholder=''
                value={preferredName}
                onChange={setPreferredName}
            />
            <PhoneNumberInput
                disabled
                label='Phone number'
                showErrorMessage
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
            />
            <Input
                disabled
                label='Email'
                type='email'
                validation='Email'
                placeholder=''
                value={userAttributes?.email || ''}
            />
            <DatePicker
                showErrorMessage
                selectedDate={DOB}
                label='Date of birth'
                placeholder='MM-DD-YYYY'
                setSelectedDate={setDOB}
                errorMessage={(DOB && !birthDateValidation(DOB)) ? errorMessages.birthDate : ''}
            />
            <Input
                type='text'
                label='Address'
                placeholder=''
                value={address}
                onChange={setAddress}
            />
            <Input
                label='City'
                type='text'
                value={city}
                placeholder=''
                onChange={setCity}
            />
            <Input
                type='text'
                placeholder=''
                label='Country'
                value={country}
                onChange={setCountry}
            />
            <div className={styles.state_zip}>
                <Input
                    type='text'
                    label='State'
                    value={state}
                    placeholder=''
                    onChange={setState}
                    wrapperClassName={styles.state_zip_state}
                />
                <Input
                    type='text'
                    label='Zip code'
                    maxLength={7}
                    placeholder=''
                    value={zipCode}
                    onChange={setZipCode}
                    wrapperClassName={styles.state_zip_zipCode}
                />
            </div>
            <Input
                label='Linkedin link (Optional)'
                type='text'
                placeholder=''
                value={linkedinLink}
                onChange={setLinkedinLink}
            />
            <Button
                text='Save'
                onClick={next}
                loading={isLoading}
                className={styles.next}
                disabled={
                    !firstName ||
                    !lastName ||
                    !address ||
                    !state ||
                    !city ||
                    !phoneNumber ||
                    !userAttributes?.email ||
                    !birthDateValidation(DOB)
                }
            />
        </Modal>
    )
}
